import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {CellMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/CellMenuItems';
import {ComponentMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/ComponentMenuItems';
import {DesignMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/DesignMenuItems';
import {EditMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/EditMenuItems';
import {ViewMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/ViewMenuItems';
import {ContextMenu, IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {HelpMenuItems} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topMenu/HelpMenuItems';

const styles = require('./CollapsedTopMenu.less');
const cx = classnames.bind(styles);

export interface ICollapsedTopMenuProps
{
    isOpen:boolean;
    target:JSX.Element;
    onHide?:() => (void);
}

@observer
export class CollapsedTopMenu extends React.Component<ICollapsedTopMenuProps>
{
    @bind
    private _handleHideMenu()
    {
        if( this.props.onHide )
            this.props.onHide();
    }

    public render()
    {
        const {isOpen, target} = this.props;

        return (
            <ContextMenu
                isOpen={isOpen}
                contentClassName={cx('menuContent')}
                dataSource={this._getMenuItems()}
                onHide={this._handleHideMenu}
                popupGroup={'collapsed-top-menu-group'}
            >
                {target}
            </ContextMenu>
        );
    }

    private _getMenuItems():IContextMenuItem[]
    {
        return [
            {
                label: 'All designs',
                handler: () => controllers.navigation.toAppHome(),
                icon: <WSPIcon className={cx('icon')} name={WSPIcons.visualDesigner.topBar.Back} />
            },
            {
                isSeparator: true
            },
            {
                label: 'Design',
                dataSource: DesignMenuItems.build()
            },
            {
                label: 'Edit',
                dataSource: EditMenuItems.build()
            },
            {
                label: 'View',
                dataSource: ViewMenuItems.build()
            },
            {
                isSeparator: true
            },
            // {
            //     label: 'Component',
            //     dataSource: ComponentMenuItems.build(),
            //     isDisabled: true
            // },
            // {
            //     label: 'Cell',
            //     dataSource: CellMenuItems.build(),
            //     isDisabled: true
            // },
            // {
            //     isSeparator: true
            // },
            {
                label: 'Help',
                dataSource: HelpMenuItems.build()
            }
        ];
    }

}
